import { render, staticRenderFns } from "./PairedListCollectionCreator.vue?vue&type=template&id=59d198aa&"
import script from "./PairedListCollectionCreator.vue?vue&type=script&lang=js&"
export * from "./PairedListCollectionCreator.vue?vue&type=script&lang=js&"
import style0 from "./PairedListCollectionCreator.vue?vue&type=style&index=0&id=59d198aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports